import styled, { css } from 'styled-components';
import indents from '../../constants/js/indents.js';
import colors from '../../constants/js/colors.js';
import border from '../../constants/js/border.js';
import { constantSize } from './constant';
import { transitionCssMixin } from '../../mixins/custom';
export const StyledIcon = styled.span.withConfig({
  componentId: "Checkbox__sc-9ttf87-0"
})(["box-sizing:border-box;display:flex;align-items:center;justify-content:center;flex-shrink:0;border:2px solid ", ";", " color:transparent;", "}", " ", ""], ({
  theme
}) => {
  var _a;

  return (_a = theme.Checkbox) === null || _a === void 0 ? void 0 : _a.state.default.borderColor;
}, transitionCssMixin('border-color'), ({
  isDisabled
}) => isDisabled && css(["border-color:", ";"], ({
  theme
}) => {
  var _a;

  return (_a = theme.Checkbox) === null || _a === void 0 ? void 0 : _a.state.disabled.borderColor;
}), ({
  size
}) => {
  var _a, _b, _c, _d;

  return size && css(["border-radius:", ";width:", ";height:", ";margin-top:", ";"], (_a = constantSize[size]) === null || _a === void 0 ? void 0 : _a.borderRadius, (_b = constantSize[size]) === null || _b === void 0 ? void 0 : _b.width, (_c = constantSize[size]) === null || _c === void 0 ? void 0 : _c.height, (_d = constantSize[size]) === null || _d === void 0 ? void 0 : _d.marginTopIcon);
}, ({
  isError,
  theme
}) => {
  var _a;

  return isError && css(["border-color:", ";"], (_a = theme.Checkbox) === null || _a === void 0 ? void 0 : _a.state.error.borderColor);
});
export const StyledLabel = styled.label.withConfig({
  componentId: "Checkbox__sc-9ttf87-1"
})(["display:", ";align-items:center;cursor:", ";gap:", ";", " color:", ";", " ", " ", ""], ({
  isBordered
}) => isBordered ? 'flex' : 'inline-flex', ({
  isDisabled
}) => isDisabled ? 'default' : 'pointer', indents.indentXS, ({
  size
}) => {
  var _a;

  return size && ((_a = constantSize[size]) === null || _a === void 0 ? void 0 : _a.textSize);
}, ({
  isDisabled,
  theme
}) => {
  var _a, _b;

  return isDisabled ? (_a = theme.Checkbox) === null || _a === void 0 ? void 0 : _a.state.disabled.color : (_b = theme.Checkbox) === null || _b === void 0 ? void 0 : _b.state.default.color;
}, ({
  isBordered,
  size
}) => {
  var _a;

  return isBordered && size && css(["border:1px solid ", ";border-radius:", ";box-sizing:border-box;padding:", ";"], colors.minorGrayLighten, border.borderRadius, (_a = constantSize[size]) === null || _a === void 0 ? void 0 : _a.paddingBordered);
}, ({
  isBordered,
  isDisabled,
  theme
}) => {
  var _a;

  return isBordered && !isDisabled && css(["&:hover{border-color:", ";}"], (_a = theme.Checkbox) === null || _a === void 0 ? void 0 : _a.state.hover.borderColor);
}, ({
  isDisabled,
  theme
}) => {
  var _a;

  return !isDisabled && css(["&:hover ", "{border-color:", ";}"], StyledIcon, (_a = theme.Checkbox) === null || _a === void 0 ? void 0 : _a.state.hover.borderColor);
});
export const StyledInput = styled.input.withConfig({
  componentId: "Checkbox__sc-9ttf87-2"
})(["display:none;&:checked ~ ", "{color:", ";border-color:", ";background-color:", ";}&:disabled:checked ~ ", "{color:", ";border-color:", ";background-color:", ";}"], StyledIcon, ({
  theme
}) => {
  var _a;

  return (_a = theme.Checkbox) === null || _a === void 0 ? void 0 : _a.state.checked.colorIcon;
}, ({
  theme
}) => {
  var _a;

  return (_a = theme.Checkbox) === null || _a === void 0 ? void 0 : _a.state.checked.borderColor;
}, ({
  theme
}) => {
  var _a;

  return (_a = theme.Checkbox) === null || _a === void 0 ? void 0 : _a.state.checked.bg;
}, StyledIcon, ({
  theme
}) => {
  var _a;

  return (_a = theme.Checkbox) === null || _a === void 0 ? void 0 : _a.state.checkedDisabled.colorIcon;
}, ({
  theme
}) => {
  var _a;

  return (_a = theme.Checkbox) === null || _a === void 0 ? void 0 : _a.state.checkedDisabled.borderColor;
}, ({
  theme
}) => {
  var _a;

  return (_a = theme.Checkbox) === null || _a === void 0 ? void 0 : _a.state.checkedDisabled.bg;
});